import horn from '../../assets/horn.png'
import ecom from '../../assets/ecom.png'
import health from '../../assets/health.png'
import chatgpt from '../../assets/cahtGpt.png'
import vm from "../../assets/vm.png"
import blog from '../../assets/blog.png'
import chatApp from '../../assets/chatApp.png'

const Parray = [
    {
        image:health,
        slogan:"HealthHub Connect",
        link:"https://github.com/Pacific077/Health",
        proj:"https://we-care-urb2.onrender.com/"
    },
    {   image:chatApp,
        slogan:"Chat App",
        link:"https://github.com/Pacific077/Chat-App",
        proj:"https://chatappflippr.onrender.com/"
    },
    {
        image:blog,
        slogan:"BlogBloom",
        link:"https://github.com/Pacific077/Blog_app",
        proj:"https://blog-app-ecph.onrender.com"
    },
    {   image:chatgpt,
        slogan:"IntellectChat",
        link:"https://github.com/Pacific077/Chat_gpt",
        proj:""
    },
    {
        image:vm,
        slogan:"Virtual Manager",
        link:"https://github.com/Pacific077/bussiness_managment",
        proj:""
    },

    {
    image:horn,
    slogan:"Video streamer",
    link:"https://github.com/Pacific077/horn_hub",
    proj:"https://pacific077.github.io/"
},
    {
    image:ecom,
    slogan:"E-Commerce Frontend",
    link:"https://github.com/Pacific077/ecommerce",
    proj:"https://pacific077.github.io/ecommerce/"
},

];

export default Parray;